import { listToObj, objToList } from 'utils/util'

// 申请时可选的信用类型list
export const CREDIT_TYPE_LIST = [
  {
    label: '信用限额',
    value: '1',
  },
  {
    label: '正常额度',
    value: '2',
  },
  {
    label: '临时额度',
    value: '3',
  },
  {
    label: '专项额度',
    value: '4',
  },
  {
    label: '信用限额 + 正常额度',
    value: '5',
  },
  {
    label: '信用限额 + 临时额度',
    value: '6',
  },
  {
    label: '信用限额 + 专项额度',
    value: '7',
  },
]

// 信用类型的key-value对象
export const CREDIT_TYPE_OBJ = listToObj(CREDIT_TYPE_LIST)

// 信用申请时type对应值
export const CREDIT_TYPE_VALUE_OBJ = {
  CREDIT_TYPE: 1,
  NORMAL_TYPE: 2,
  TEMPORARY_TYPE: 3,
  SPECIAL_TYPE: 4,
  CREDIT_NORMAL_TYPE: 5,
  CREDIT_TEMPORARY_TYPE: 6,
  CREDIT_SPECIAL_TYPE: 7,
}

// 控货条件list
export const LIMIT_CONDITION_TYPE_LIST = [
  {
    label: '无',
    value: '',
  },
  {
    label: '控货',
    value: 1,
  },
]

// 审核状态的key-value对象
export const APPROVAL_STATUS_OBJ = {
  1: {
    label: '待审批',
    color: 'blue',
  },
  2: {
    label: '审批通过',
    color: 'green',
  },
  3: {
    label: '审批拒绝',
    color: 'red',
  },
  4: {
    label: '已撤销',
    color: 'gray',
  },
}

// 审核状态list
export const APPROVAL_STATUS_LIST = [
  { text: '全部', value: 0 },
  ...objToList(APPROVAL_STATUS_OBJ, 'text'),
]

export const APPROVAL_STATUS_VALUE_OBJ = {
  INIT: 0,
  PADDING: 1,
  PASSED: 2,
  REJECT: 3,
  REVERT: 4,
}

export const BATCH_STATUS_OBJ = {
  0: {
    label: '待验证',
    color: 'pink',
  },
  1: {
    label: '验证通过',
    color: 'cyan',
  },
  2: {
    label: '验证不通过',
    color: 'orange',
  },
  3: {
    label: '审批中',
    color: 'blue',
  },
  4: {
    label: '审批通过',
    color: 'green',
  },
  5: {
    label: '审批拒绝',
    color: 'red',
  },
}

// 批量申请状态list
export const BATCH_STATUS_LIST = [
  {
    text: '全部',
    value: '',
  },
  ...objToList(BATCH_STATUS_OBJ, 'text'),
]
